import { AppearanceTypes, Base, BaseProps } from './base';
import styles from './styles.scss';
import cn from 'classnames';
import { forwardRef } from 'react';

export type BlockProps = BaseProps<AppearanceTypes>;

export const Block = forwardRef<HTMLDivElement, BlockProps>(
  ({ className, children, appearance = 'secondary', ...base }, ref) => (
    <Base {...base} appearance={appearance} className={cn(styles.block, className)} ref={ref}>
      {children}
    </Base>
  )
);
